import usePartyStore from "../../stores/party.js";
import { Results, log } from "@tumbodash/browserPackages";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyRecord = Record<string, any>;

function aggregateResults() {
	log.fx("module:party:aggregateResults");
	const party = usePartyStore.getState().party!;
	const shell = Results.shell(party.players as unknown as AnyRecord);
	const rounds = JSON.parse(JSON.stringify(party.rounds)) as AnyRecord;
	rounds["0"] = { results: shell };
	const aggregatedResults = Results.aggregate(rounds);

	Object.keys(aggregatedResults).forEach((playerId) => {
		const penalty = (party.players as AnyRecord)[playerId]?.skipPenalty ?? 0;
		aggregatedResults[playerId].score -= penalty;
	});

	const positionedResults = Results.assignPositions(aggregatedResults);
	const sortedResults = Results.sortPlayers(positionedResults as unknown as AnyRecord);
	return sortedResults;
}

export default aggregateResults;
